// Losse module zodat zowel het lijst- als het kalenderoverzicht dezelfde
// kleurtaal gebruikt zonder een van beide te importeren (cyclus).
/** Badge-stijl per planningstatus — dezelfde kleurtaal als de Airtable-interface. */
export const PLANNINGSTATUS_STIJL = {
  'Montage ingepland': { bg: '#dcfce7', fg: '#166534' },
  // Blauw i.p.v. grijs, zodat het verschil met 'Geen montage nodig' zichtbaar is (feedback #50).
  'Montage ingepland - Niet assigned': { bg: '#dbeafe', fg: '#1e40af' },
  'Geen montage nodig': { bg: '#e2e8f0', fg: '#475569' },
  'Geen taken na draaidag': { bg: '#fce7f3', fg: '#9d174d' },
  'Geen project gekoppeld': { bg: '#fef3c7', fg: '#92400e' },
};
